import React from "react";
import "./DriverStatus.scss";

const AdditionalVehicleStatus = ({ status }) => {
  return <div className={`driver-status ${status}`}>{status}</div>;
};
export default React.memo(AdditionalVehicleStatus);
